// src/ExpiringBanner.jsx
// ─────────────────────────────────────────────
// 수강 만료 7일 이내 학습자에게 표시하는 상단 배너
// LessonLayout 상단에 조건부 렌더링으로 사용
// ─────────────────────────────────────────────

import React from 'react';
import { useAuth } from './AuthContext';

export default function ExpiringBanner() {
  const { studentStatus, studentDoc } = useAuth();

  if (studentStatus !== 'expiring-soon') return null;

  const daysLeft = studentDoc?.expiresAt
    ? Math.max(0, Math.ceil((studentDoc.expiresAt.toMillis() - Date.now()) / 86_400_000))
    : 0;

  const expDate = studentDoc?.expiresAt
    ? studentDoc.expiresAt.toDate().toLocaleDateString('ko-KR', {
        month: 'long', day: 'numeric',
      })
    : '';

  return (
    <div style={styles.banner}>
      <span style={styles.icon}>⏰</span>
      <span style={styles.text}>
        수강 기간이 <strong>{daysLeft}일</strong> 남았습니다.
        {expDate && ` (만료일: ${expDate})`}
        &nbsp;기간 연장이 필요하시면 담당자에게 문의해 주세요.
      </span>
    </div>
  );
}

const styles = {
  banner: {
    display: 'flex', alignItems: 'center', gap: '8px',
    background: '#FDF3E7',
    borderBottom: '0.5px solid #F5D5A8',
    padding: '10px 20px',
    fontSize: '13px', color: '#854F0B',
  },
  icon: { fontSize: '14px', flexShrink: 0 },
  text: { lineHeight: '1.5' },
};
